import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '@/utils/api';
import { useWebSocket } from '@/contexts/WebSocketContext';
import { isDecor } from '@/modern/shared';

// Estados de mesa calculados en el servidor; llegan en vivo por WebSocket ('table_states')
export const useTableStates = () => {
  const { subscribe, connected } = useWebSocket();
  const [units, setUnits] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [now, setNow] = useState(Date.now());

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_BASE}/tables/states`);
      setUnits(data.units || []);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => subscribe('table_states', (msg) => setUnits(msg.units || [])), [subscribe]);
  useEffect(() => {
    const id = setInterval(refresh, connected ? 120000 : 15000);
    return () => clearInterval(id);
  }, [connected, refresh]);
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(id);
  }, []);

  // Decorados del plano (plantas, barra, fondo...) no son mesas
  return { units: units.filter(u => !isDecor(u)), decor: units.filter(isDecor), loaded, refresh, now };
};
